export const RECEIVE_DAY_SCHEDULES = 'RECEIVE_DAY_SCHEDULES'
export const RECEIVE_DAY_SCHEDULE = 'RECEIVE_DAY_SCHEDULE'
export const ADD_DAY_SCHEDULE = 'ADD_DAY_SCHEDULE'
export const EDIT_DAY_SCHEDULE = 'EDIT_DAY_SCHEDULE'
export const DELETE_DAY_SCHEDULE = 'DELETE_DAY_SCHEDULE'
export const RECEIVE_DAY_SCHEDULE_ITEMS = 'RECEIVE_DAY_SCHEDULE_ITEMS'
export const RECEIVE_DAY_SCHEDULE_ITEM = 'RECEIVE_DAY_SCHEDULE_ITEM'
export const RECIEVE_DAY_SCHEDULE_ITEM_AT_INTERVAL = 'RECIEVE_DAY_SCHEDULE_ITEM_AT_INTERVAL'
export const CHANGE_SELECTED_DAY_SCHEDULE_ID = 'CHANGE_SELECTED_DAY_SCHEDULE_ID'
export const ADD_DAY_SCHEDULE_ITEM = 'ADD_DAY_SCHEDULE_ITEM'
export const EDIT_DAY_SCHEDULE_ITEM = 'EDIT_DAY_SCHEDULE_ITEM'
export const DELETE_DAY_SCHEDULE_ITEM = 'DELETE_DAY_SCHEDULE_ITEM'
export const DELETE_MULTIPLE_DAY_SCHEDULE_ITEMS = 'DELETE_MULTIPLE_DAY_SCHEDULE_ITEMS'

export const RECEIVE_DEFAULT_SCHEDULE = 'RECEIVE_DEFAULT_SCHEDULE'

export const RECEIVE_CALENDAR_EVENTS = 'RECEIVE_CALENDAR_EVENTS'
export const RECEIVE_CALENDAR_EXCEPTION_DATA_FOR_DATE = 'RECEIVE_CALENDAR_EXCEPTION_DATA_FOR_DATE'

export const RECEIVE_DEVICES = 'RECEIVE_DEVICES'
export const SORT_DEVICES = 'SORT_DEVICES'
export const RECEIVE_DEVICE = 'RECEIVE_DEVICE'
export const ADD_DEVICE = 'ADD_DEVICE'
export const EDIT_DEVICE = 'EDIT_DEVICE'
export const DELETE_DEVICE = 'DELETE_DEVICE'
export const RECIEVE_DEVICE_TYPES = 'RECIEVE_DEVICE_TYPES'
export const RECEIVE_DEVICE_SIP_TYPES = 'RECEIVE_DEVICE_SIP_TYPES'

export const RECEIVE_ZONES = 'RECEIVE_ZONES'
export const RECEIVE_ZONE = 'RECEIVE_ZONE'
export const RECEIVE_AVAILABLE_DEVICES = 'RECEIVE_AVAILABLE_DEVICES'
export const RECEIVE_AVAILABLE_ZONES = 'RECEIVE_AVAILABLE_ZONES'
export const ADD_ZONE = 'ADD_ZONE'
export const EDIT_ZONE = 'EDIT_ZONE'
export const DELETE_ZONE = 'DELETE_ZONE'
export const RECEIVE_ZONE_TYPES = 'RECEIVE_ZONE_TYPES'

export const RECEIVE_SOUNDS = 'RECEIVE_SOUNDS'
export const RECEIVE_SOUND_TYPES = 'RECEIVE_SOUND_TYPES'
export const UPLOAD_SOUND = 'UPLOAD_SOUND'
export const DELETE_SOUND = 'DELETE_SOUND'

export const RECEIVE_COMMAND_RESULT = 'RECEIVE_COMMAND_RESULT'

export const RECEIVE_CURRENT_TIME_RESULT = 'RECEIVE_CURRENT_TIME_RESULT'
export const INCREMENT_CURRENT_TIME = 'INCREMENT_CURRENT_TIME'

export const RECEIVE_MACHINE_TYPE = 'RECEIVE_MACHINE_TYPE'

export const RECEIVE_SCHEDULE_INFO = 'RECEIVE_SCHEDULE_INFO'

export const RECEIVE_STOP_ACTIVE_BELLS_RESULT = 'RECEIVE_STOP_ACTIVE_BELLS_RESULT'
export const RECEIVE_STOP_ACTIVE_ALERTS_RESULT = 'RECEIVE_STOP_ACTIVE_ALERTS_RESULT'

export const RECEIVE_MAPS = 'RECEIVE_MAPS'
export const RECEIVE_POLYGONS = 'RECEIVE_POLYGONS'
export const RECEIVE_MAP_DEVICES = 'RECEIVE_MAP_DEVICES'
export const ADD_MAP = 'ADD_MAP'
export const DELETE_MAP = 'DELETE_MAP'

export const RECEIVE_ZONE_EXCEPTIONS = 'RECEIVE_ZONE_EXCEPTIONS'
export const ADD_ZONE_EXCEPTION = 'ADD_ZONE_EXCEPTION'
export const DELETE_ZONE_EXCEPTION = 'DELETE_ZONE_EXCEPTION'

export const RECEIVE_NOTIFICATIONS = 'RECEIVE_NOTIFICATIONS'
export const RECEIVE_NOTIFICATION = 'RECEIVE_NOTIFICATION'
export const RECEIVE_PLAY_NOTIFICATION_RESULT = 'RECEIVE_PLAY_NOTIFICATION_RESULT'
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const EDIT_NOTIFICATION = 'EDIT_NOTIFICATION'
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION'

export const RECEIVE_LOG = 'RECEIVE_LOG'
export const CLEAR_LOG = 'CLEAR_LOG'

export const RECEIVE_SERVICES = 'RECEIVE_SERVICES'
export const RESTART_SERVICE = 'RESTART_SERVICE'

export const RECEIVE_CONSOLE_COMMAND_RESULT = 'RECEIVE_CONSOLE_COMMAND_RESULT'

export const RECEIVE_NETWORK_INTERFACES = 'RECEIVE_NETWORK_INTERFACES'
export const SAVE_NETWORK_INTERFACES = 'SAVE_NETWORK_INTERFACES'

export const RECEIVE_DNS_SERVERS = 'RECEIVE_DNS_SERVERS'
export const ADD_DNS_SERVER = 'ADD_DNS_SERVER'
export const DELETE_DNS_SERVER = 'DELETE_DNS_SERVER'

export const RECEIVE_TIME_ZONES = 'RECEIVE_TIME_ZONES'
export const RECEIVE_CURRENT_TIME_ZONE = 'RECEIVE_CURRENT_TIME_ZONE'
export const SET_CURRENT_TIME_ZONE = 'SET_CURRENT_TIME_ZONE'

export const RECEIVE_TIME_SERVERS = 'RECEIVE_TIME_SERVERS'
export const ADD_TIME_SERVER = 'ADD_TIME_SERVER'
export const DELETE_TIME_SERVER = 'DELETE_TIME_SERVER'

export const RECEIVE_HOST_NAME = 'RECEIVE_HOST_NAME'
export const SET_HOST_NAME = 'SET_HOST_NAME'

export const RECEIVE_STORAGES = 'RECEIVE_STORAGES'

export const RECEIVE_USER = 'RECEIVE_USER'
export const RECEIVE_USERS = 'RECEIVE_USERS'
export const RECEIVE_GROUPS = 'RECEIVE_GROUPS'
export const ADD_USER = 'ADD_USER'
export const EDIT_USER = 'EDIT_USER'
export const DELETE_USER = 'DELETE_USER'

export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'

// export const RECEIVE_DEFAULT_BACKUP = 'RECEIVE_DEFAULT_BACKUP'
export const RECEIVE_BACKUP_FREQUENCIES = 'RECEIVE_BACKUP_FREQUENCIES'
export const RECEIVE_BACKUP_LOCATION_TYPES = 'RECEIVE_BACKUP_LOCATION_TYPES'
export const RECEIVE_BACKUP_LOCATION = 'RECEIVE_BACKUP_LOCATION'
export const RECEIVE_BACKUP_LOCATIONS = 'RECEIVE_BACKUP_LOCATIONS'
export const ADD_BACKUP_LOCATION = 'ADD_BACKUP_LOCATION'
export const EDIT_BACKUP_LOCATION = 'EDIT_BACKUP_LOCATION'
export const DELETE_BACKUP_LOCATION = 'DELETE_BACKUP_LOCATION'
export const RECEIVE_BACKUP_SCHEDULE = 'RECEIVE_BACKUP_SCHEDULE'
export const RECEIVE_BACKUP_SCHEDULES = 'RECEIVE_BACKUP_SCHEDULES'
export const ADD_BACKUP_SCHEDULE = 'ADD_BACKUP_SCHEDULE'
export const EDIT_BACKUP_SCHEDULE = 'EDIT_BACKUP_SCHEDULE'
export const DELETE_BACKUP_SCHEDULE = 'DELETE_BACKUP_SCHEDULE'

export const ADD_ALERT = 'ADD_ALERT'
export const EDIT_ALERT = 'EDIT_ALERT'
export const DELETE_ALERT = 'DELETE_ALERT'
export const RECEIVE_ALERTS = 'RECEIVE_ALERTS'
export const RECEIVE_ALERT = 'RECEIVE_ALERT'
export const RECEIVE_ALERT_ACTION_TYPES = 'RECEIVE_ALERT_ACTION_TYPES'
export const RECEIVE_ALERT_STEPS = 'RECEIVE_ALERT_STEPS'
export const RECEIVE_ALERT_STEP = 'RECEIVE_ALERT_STEP'
export const ADD_ALERT_STEP = 'ADD_ALERT_STEP'
export const EDIT_ALERT_STEP = 'EDIT_ALERT_STEP'
export const DELETE_ALERT_STEP = 'DELETE_ALERT_STEP'
export const RECEIVE_ALERT_STEP_ORDER_TYPES = 'RECEIVE_ALERT_STEP_ORDER_TYPES'
export const RECEIVE_ALERT_STEP_COMMAND_TYPES = 'RECEIVE_ALERT_STEP_COMMAND_TYPES'

export const ADD_INTERCOM_EXTERNAL_SIP = 'ADD_RECEIVE_INTERCOM_SIP'
export const EDIT_INTERCOM_EXTERNAL_SIP = 'EDIT_RECEIVE_INTERCOM_SIP'
export const DELETE_INTERCOM_EXTERNAL_SIP = 'DELETE_RECEIVE_INTERCOM_SIP'
export const RECEIVE_INTERCOM_EXTERNAL_SIP = 'RECEIVE_INTERCOM_SIP'
export const RECEIVE_INTERCOM_EXTERNAL_SIPS = 'RECEIVE_INTERCOM_SIPS'

export const RECEIVE_PHOENIX_SETTING = 'RECEIVE_PHOENIX_SETTING'
export const EDIT_PHOENIX_SETTING = 'EDIT_PHOENIX_SETTING'
export const RECEIVE_PHOENIX_SETTINGS = 'RECEIVE_PHOENIX_SETTINGS'
export const EDIT_PHOENIX_SETTINGS = 'EDIT_PHOENIX_SETTINGS'

export const RECEIVE_SITE = 'RECEIVE_SITE'
export const RECEIVE_SITES = 'RECEIVE_SITES'
export const ADD_SITE = 'ADD_SITE'
export const EDIT_SITE = 'EDIT_SITE'
export const DELETE_SITE = 'DELETE_SITE'
export const CHANGE_SCOPED_SITE_ID = 'CHANGE_SCOPED_SITE_ID'
export const DETERMINED_SITE_OF_IP = 'DETERMINED_SITE_OF_IP'
export const TOGGLE_DISABLED_CHANGE_SCOPED_SITE = 'TOGGLE_DISABLED_CHANGE_SCOPED_SITE'

export const RECEIVE_CONTACT = 'RECEIVE_CONTACT'
export const RECEIVE_CONTACTS = 'RECEIVE_CONTACTS'
export const ADD_CONTACT = 'ADD_CONTACT'
export const EDIT_CONTACT = 'EDIT_CONTACT'
export const DELETE_CONTACT = 'DELETE_CONTACT'

export const RECEIVE_ADVANCED_VISUAL = 'RECEIVE_ADVANCED_VISUAL'
export const RECEIVE_ADVANCED_VISUALS = 'RECEIVE_ADVANCED_VISUALS'
export const ADD_ADVANCED_VISUAL = 'ADD_ADVANCED_VISUAL'
export const EDIT_ADVANCED_VISUAL = 'EDIT_ADVANCED_VISUAL'
export const DELETE_ADVANCED_VISUAL = 'DELETE_ADVANCED_VISUAL'

export const RECEIVE_SERVER_OBJECTS = 'RECEIVE_SERVER_OBJECTS'
export const RECEIVE_SERVER_OBJECT = 'RECEIVE_SERVER_OBJECT'

export const RECEIVE_PLAYLISTS = 'RECEIVE_PLAYLISTS'
export const RECEIVE_PLAYLIST = 'RECEIVE_PLAYLIST'
export const ADD_PLAYLIST = 'ADD_PLAYLIST'
export const EDIT_PLAYLIST = 'EDIT_PLAYLIST'
export const DELETE_PLAYLIST = 'DELETE_PLAYLIST'
export const RECEIVE_PLAYLIST_ITEMS = 'RECEIVE_PLAYLIST_ITEMS'
export const ADD_PLAYLIST_ITEM = 'ADD_PLAYLIST_ITEM'
export const DELETE_PLAYLIST_ITEM = 'DELETE_PLAYLIST_ITEM'

export const RECEIVE_BANNED_IP = 'RECEIVE_BANNED_IP'
export const BAN_IP = 'BAN_IP'
export const UNBAN_IP = 'UNBAN_IP'
export const RECEIVE_IGNORED_IPS = 'RECEIVE_IGNORED_IPS'
export const IGNORE_IP = 'IGNORE_IP'
export const UNIGNORE_IP = 'UNIGNORE_IP'

export const RECEIVE_VERSION = 'RECEIVE_VERSION'
